import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { DemandResponsePlaceholder } from '../../components/NextGenDashboard/DemandResponsePlaceholder';
import { NextGenDashboard } from '../../components/NextGenDashboard/NextGenDashboard';
import { DashboardConnectProvider } from '../../components/Dashboard/shared/DashboardConnectProvider';
import { DashboardPageHeader } from '../../components/Dashboard/DashboardPageHeader';
import { AccessDeniedNotice } from '../../components/Shared/AccessDeniedNotice';
import { useDataFromParams } from '../../hooks/useDataFromParams';
import { DashboardFooter } from './layout/DashboardFooter';
import { DashboardHeader } from './layout/DashboardHeader';

export const CategoryScreen = () => {
  const { category } = useParams();
  const { property, propertyAccessDenied } = useDataFromParams();
  const routeTileId = category ?? "building";
  const initialTileId = routeTileId;

  const tileLabel = useMemo(() => {
    const map: Record<string, string> = {
      building: "Building Performance",
      solar: "Power Generation",
      ev: "EV Charging",
      carbon: "Carbon Emissions",
      battery: "Battery",
      dr: "Demand Response / VPP",
    };
    return map[initialTileId] ?? "Detail Dashboard";
  }, [initialTileId]);

  // EV and DR / VPP are on the mid-fi pass (4019); the other detail pages keep the existing background.
  const isMidFi = initialTileId === "ev" || initialTileId === "dr";

  return (
    <div className="h-full font-sans flex flex-col">
      <DashboardHeader />
      <div className={isMidFi ? "bg-mf-bg" : "bg-zeos-white-md"}>
        <DashboardPageHeader
          showCategory
          propertyCategoryName={tileLabel}
        />
        {propertyAccessDenied ? (
          <AccessDeniedNotice resource="property" />
        ) : initialTileId === "dr" ? (
          // No DR data source yet (DB-F5): render the sheet-06 placeholder rather than the
          // generic tile, which would only show a single "coming soon" banner.
          <DemandResponsePlaceholder />
        ) : (
          <DashboardConnectProvider>
            <NextGenDashboard
              key={routeTileId}
              propertyId={property?.propertyId}
              companyId={property?.companyId}
              initialTileId={initialTileId}
            />
          </DashboardConnectProvider>
        )}
      </div>
      <div className="bg-zeos-white-md">
        <DashboardFooter />
      </div>
    </div>
  );
};
